import { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { Box, Columns, Column, Bleed, Divider } from '@machobear/design-system'
import { breakpoints } from '@/styles'
import usePayments from '@/hooks/use-payments'
import useMediaQuery from '@/hooks/use-media-query'
import PaymentMethod from '@/components/ds-checkout-modal/payment-method'
import PurchaseSummary from '@/components/ds-checkout-modal/purchase-summary'
import { useWizardContext } from '@/components/modal-wizard-form/wizard-context'

//needs to be in a wizard and formik contexts to work
const CheckoutStep = ({ isLoadingProduct }: { isLoadingProduct?: boolean }) => {
  const { values }: { values: { state: string; country: string } } = useFormikContext()
  const { paymentInfo = [], loading } = usePayments()
  const hasPaymentMethods = paymentInfo && paymentInfo?.length !== 0

  const isMobile = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)
  const { setIsLoading, setLoadingFinished } = useWizardContext()

  useEffect(() => {
    if (isLoadingProduct) setIsLoading()
    else setLoadingFinished()
  }, [isLoadingProduct, setIsLoading, setLoadingFinished])

  return (
    <Box style={{ maxWidth: isMobile ? '100%' : '940px' }}>
      <Bleed horizontal={{ mobile: 'medium', desktop: 'large' }}>
        <Divider />
        <Columns space="none" collapseBelow="tablet">
          <Column width="2/5">
            <PurchaseSummary
              state={hasPaymentMethods ? paymentInfo[0]?.state : values.state}
              country={hasPaymentMethods ? paymentInfo[0]?.country : values.country}
              setIsLoading={setIsLoading}
              isProductLoading={isLoadingProduct}
              setLoadingFinished={setLoadingFinished}
            />
          </Column>
          <Column width="3/5">
            <Box display="flex" flexDirection="column" justifyContent="spaceBetween">
              <PaymentMethod isLoading={loading || !!isLoadingProduct} paymentInfo={paymentInfo} />
            </Box>
          </Column>
        </Columns>
      </Bleed>
    </Box>
  )
}

export default CheckoutStep
